type TableVariantStyles = {
    table?: Record<string, unknown>;
    th?: Record<string, unknown>;
    td?: Record<string, unknown>;
    thead?: {
        tr?: Record<string, unknown>;
    };
};

type TableVariants = {
    [variantName: string]: TableVariantStyles;
};

export const variants: TableVariants = {
    rounded: {
        table: {
            boxShadow: 'none',
            marginBottom: 0,
        },
        th: {
            textTransform: 'uppercase',
        },
        td: {
            fontSize: 'sm',
        },
        thead: {
            tr: {
                color: 'gray.600',
                backgroundColor: 'gray.50',
            },
        },
    },
};
